import { apiFetch, apiGetJSON, ApiError } from "./client";
import type { RecordingTag } from "../types";

export async function listTags(): Promise<RecordingTag[]> {
  return (await apiGetJSON<{ tags: RecordingTag[] }>("/v1/tags")).tags;
}
async function write(path: string, method: string, body?: unknown): Promise<Response> {
  const res = await apiFetch(path, {
    method,
    ...(body === undefined
      ? {}
      : { headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }),
  });
  if (!res.ok) throw new ApiError(res.status, "Не удалось выполнить действие с меткой");
  return res;
}
export async function createTag(name: string): Promise<RecordingTag> {
  return (await (await write("/v1/tags", "POST", { name })).json()) as RecordingTag;
}
export async function updateTag(tag: RecordingTag): Promise<void> {
  await write(`/v1/tags/${encodeURIComponent(tag.id)}`, "PUT", tag);
}
export async function tagImpact(id: string): Promise<{ recordings: number; version: number }> {
  return await apiGetJSON<{ recordings: number; version: number }>(
    `/v1/tags/${encodeURIComponent(id)}/impact`,
  );
}
export async function linkTag(
  recording: string,
  tag: string,
  attach: boolean,
  version?: number,
): Promise<void> {
  await write(
    `/v1/recordings/${encodeURIComponent(recording)}/tags/${encodeURIComponent(tag)}`,
    attach ? "PUT" : "DELETE",
    attach ? { version } : undefined,
  );
}
